import { render, staticRenderFns } from "./BlurredBackground.vue?vue&type=template&id=4fc72052&scoped=true&"
import script from "./BlurredBackground.vue?vue&type=script&lang=js&"
export * from "./BlurredBackground.vue?vue&type=script&lang=js&"
import style0 from "./BlurredBackground.vue?vue&type=style&index=0&id=4fc72052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc72052",
  null
  
)

export default component.exports